import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { permission } from '../../../utils/enums/ValidationMessage';
import { ReworkProductTable } from './ReworkProductTable';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import QtyModel from '../../otherForms/storeToPlant/QtyModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

export default class ReworkProduct extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            activeTab: "items",
            idRework: null,
            isFromMaterialRejection: false,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            reworkItemObject: {
                itemName: '',
                quantity: '',
                process: '',
                idProcess: '',
                employeeName: '',
                idEmployee: '',
                processRates: '',
                processList: [],
                employeeList: [],
                keyId: null,
                isCompleteProcess: false,
                completeDate: ''
            },
            isModalOpen: false,
            isSaving: false,
            isQtyModelOpen: false,
            isSelectItemPopUp: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            bomRemovedRowData: [],
            reworkRowData: [],
            itemColDefs: [],
            bomItemData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            reworkObject: {
                reworkNo: '',
                reworkDate: '',
                idRework: '',
                updateStatus: 0,
                idReworkType: 1,
                reworkTypeList: [
                    { value: 1, label: 'FROM SALES RETURN' },
                    { value: 2, label: 'FROM STOCK' },
                ],
                idJwOut: 0,
                jwOutList: [],
                jwOutDate: '',
                avlStock: '',
                reworkQty: '',
                idProduct: 0,
                productName: '',
                productList: [],
                srNo: '',
                jwIn: '',
                jwInDate: '',
                idPlant: 0,
                plantList: [],
                idProcess: 0,
                processList: [],
                isCompleteRework: false,
                completeDate: ''
            },
            formStatus: 0, // 0 for insert, 1 for edit
            itemObject: {
                idItem: 0,
                itemList: [],
                stock: '',
                quantity: '',
                remarks: '',
                itemName: '',
                type: '',
                drawingNo: '',
                totalRequireQty: '',
                keyId: null,
                itemRate: ''
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForRework: {
                idJwOut: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "jw out"
                        ),
                    },
                ],
                idProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "productName",
                    headerName: "Product Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectQtyColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.10,
                    flex: 1.1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemType",
                    headerName: "Item Type",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemDetails",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.20,
                    flex: 2.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "requiredQuantity",
                    headerName: "Qty",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "totalRequireQty",
                    headerName: "Required Qty",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                    valueFormatter: (params) => {
                        if (params.value == null || params.value === "") return "";
                        const num = Number(params.value);
                        return Number.isInteger(num) ? num : num.toFixed(2);
                    },
                },
                {
                    field: "currentStock",
                    headerName: "Stock Qty",
                    minWidth: window.innerWidth * 0.05,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "Action",
                    headerName: "Action",
                    minWidth: window.innerWidth * 0.12,
                    flex: 0.5,
                    filter: false,
                    floatingFilter: false,
                    cellClass: "action-col !p-0 flex items-center justify-center",
                    cellRenderer: (params) => (
                        <div className="flex items-center justify-center gap-2">
                            <button
                                onClick={() => this.handleItemAdd(params.data)}
                                className='update-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                                title="Add"
                            >
                                Add
                            </button>
                            <button
                                onClick={() => this.handleItemRework(params.data)}
                                className='edit-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                                title="Rework"
                            >
                                Rework
                            </button>
                            <button
                                onClick={() => this.handleItemRemove(params.data)}
                                className='delete-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                                title="Delete"
                            >
                                {/* Remove */}
                                <FontAwesomeIcon icon={faTrash} />
                            </button>

                        </div>
                    ),
                }
            ],
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("idRework")
        if (id) {
            let idRework = decryptAES(id)
            if (idRework) {
                if (idRework != null) {
                    this.setState({ idRework: idRework, isFromMaterialRejection: true });
                } else {
                    this.setState({ isFromMaterialRejection: false });
                }
            } else {
                this.setState({ isFromMaterialRejection: false });
            }
        } else {
            this.setState({ isFromMaterialRejection: false });
        }
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.getItemCategoryList()
                this.getMasterProductSelectForProductionStock()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "ReWork Product",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                this.setPermissions(permissions);
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            pinned: ["sR.No", "invoiceFrom", "challanNo", "rejectionNo", "workOrder"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idRework",].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "ReWork Product",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "ReWork Product");
                            if (this.state.urlId) {
                                // this.openPopUpFromURLId(this.state.urlId)
                            }
                            if (this.state.idRework && this.state.isFromMaterialRejection) {
                                this.openPopUpFromRejection(this.state.idRework)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromRejection = (id) => {
        let details = this.state.reworkObject;
        details.idRework = id;
        this.setState({ reworkObject: details }, () => {
            this.getReworkById(this.state.reworkObject.idRework);
        });
    };

    getMasterProductSelectForProductionStock = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getMasterProductSelectForProductionStock(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.reworkObject;
                data.productList = [];
                if (allData.length > 0) {
                    data.productList = allData;
                }
                this.setState({ reworkObject: data });
            }
        });
    }

    getItemCategoryList = () => {
        this.transactionStockServices.usp_Master_ItemCategorySelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idItemCategory,
                    label: x.itemCategory,
                }));
                this.setState({ itemCategoryList: data }, () => {
                    this.usp_Master_ItemSelect();
                });
            } else {
                this.usp_Master_ItemSelect();
            }
        });
    }

    usp_Master_ItemSelect = () => {
        this.transactionStockServices.usp_Master_ItemSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    label: x.itemName,
                    itemCategory: x.itemCategory,
                    value: x.idItem,
                    drawingNo: x.drawingNo,
                    itemType: x.itemType
                }));
                let details = this.state.itemObject;
                details.itemList = data;
                this.setState({ itemObject: details }, () => {
                    this.usp_Master_PlantSelect();
                });
            } else {
                this.usp_Master_PlantSelect();
            }
        });
    }

    usp_Master_PlantSelect = () => {
        this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idPlant,
                    label: x.plantDetails,
                }));
                let details = this.state.reworkObject;
                details.plantList = data;
                this.setState({ reworkObject: details }, () => {
                    this.usp_Master_ProcessSelect();
                });
            } else {
                this.usp_Master_ProcessSelect();
            }
        });
    }

    usp_Master_ProcessSelect = () => {
        this.transactionStockServices.usp_Master_ProcessSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idProcess,
                    label: x.process,
                }));
                let details = this.state.reworkItemObject;
                details.processList = data;
                this.setState({ reworkItemObject: details }, () => {
                    this.usp_Transaction_MaterialJobWorkSelect_ForRework();
                });
            } else {
                this.usp_Transaction_MaterialJobWorkSelect_ForRework();
            }
        });
    }

    usp_Transaction_MaterialJobWorkSelect_ForRework = () => {
        this.transactionStockServices.usp_Transaction_MaterialJobWorkSelect_ForRework(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idMaterialJobWork,
                    label: x.jobWorkNo,
                    partyACName: x.partyACName,
                    jobWorkDate: x.jobWorkDate,
                }));
                let details = this.state.reworkObject;
                details.jwOutList = data;
                this.setState({ reworkObject: details });
            } else {
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "reworkNo": window.innerWidth * 0.05,
            "reworkDate": window.innerWidth * 0.08,
            "itemName": window.innerWidth * 0.3,
            "reworkQuantity": window.innerWidth * 0.05,
            "IsCompleteRework": window.innerWidth * 0.05,
            "Status": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.04,
            "invoiceFrom": window.innerWidth * 0.08,
            "challanNo": window.innerWidth * 0.06,
            "rejectionNo": window.innerWidth * 0.06,
            "workOrder": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.06,
            "quantity": window.innerWidth * 0.06,
            "processRates": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.usp_Transaction_ReworkCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let reworkObject = this.state.reworkObject
                reworkObject.reworkNo = formatted
                reworkObject.reworkDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ reworkObject: reworkObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetAllObject()
                        this.setState({ itemRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getReworkById(event.data.idRework);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    onItemRowDoubleClicked = (event) => {
        let row = event.data;
        if (!event || !event.data || !row) {
            this.SwalServices.Error("Please select valid item");
            return;
        }
        let itemObject = this.state.itemObject;
        itemObject.idItem = row.idItem;
        itemObject.quantity = row.totalRequireQty;
        itemObject.stock = row.currentStock;
        itemObject.type = row.isItem && row.isItem === 1 ? "ITEM" : "GROUP";
        itemObject.itemName = row.itemDetails;
        itemObject.keyId = event.rowIndex
        this.setState({
            itemObject: itemObject,
            formStatus: 1,
        });
    };

    onBomRowDoubleClicked = (event) => {
        let row = event.data;
        if (!event || !event.data || !row) {
            this.SwalServices.Error("Please select valid item");
            return;
        }
        let itemObject = this.state.itemObject;
        itemObject.idItem = row.idItem;
        itemObject.quantity = row.totalRequireQty || Number(row.quantity);
        itemObject.stock = row.currentStock;
        itemObject.type = row.isItem && row.isItem === 1 ? "ITEM" : "GROUP";
        itemObject.itemName = row.itemDetails;
        itemObject.keyId = event.rowIndex
        this.setState({
            itemObject: itemObject,
            formStatus: 1,
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.reworkObject,
            this.state.validationRulesForRework,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForRework = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.reworkObject;
        if (name === "isCompleteRework") {
            details.isCompleteRework = !details.isCompleteRework;
            details.completeDate = details.isCompleteRework ? moment(new Date().toISOString()).format('YYYY-MM-DD') : '';
        } else {
            details[name] = value;
        }
        this.setState({ reworkObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.reworkObject;
        let details1 = this.state.itemObject
        let details2 = this.state.reworkItemObject
        let value = event.value;
        if (field === 'reworkObject') {
            details[name] = value;
            this.setState({ reworkObject: details }, () => {
                if (name === 'idProduct') {
                    this.usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems(event.value);
                }
            });
        } else if (field === 'reworkItemObject') {
            details2[name] = value;
            if (name === 'idEmployee') {
                details2.employeeName = event.label
            }
            if (name === 'idProcess') {
                details2.process = event.label
            }
            this.setState({ reworkItemObject: details2 }, () => {
                if (name === 'idProcess') {
                    this.getEmployeeList();
                }
            });
        } else {
            details1[name] = value;
            if (name === 'idItem') {
                details1.itemName = event.label
                details1.itemType = event.itemType
            }
            this.setState({ itemObject: details1 }, () => {
                if (name === 'idItem') {
                    this.usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems(event.value, 'ForItem');
                }
            });
        }
    }

    usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems = (IDProduct, forITem) => {
        let request = [IDProduct, this.state.idCompany, 0];
        this.otherFormsServices.getMasterProductSelectForProductionStock2(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent[0];
                let data = this.state.reworkObject;
                let itemObject = this.state.itemObject
                if (forITem === 'ForItem') {
                    if (allData) {
                        itemObject.stock = allData.currentStock;
                        itemObject.idItem = allData.idItem;
                    }
                    this.setState({ reworkObject: data });
                } else {
                    data.avlStock = 0;
                    data.reworkQty = 0;
                    if (allData) {
                        data.avlStock = allData.currentStock;
                        data.reworkQty = allData.currentStock;
                        data.idProduct = allData.idItem;
                    }
                    this.setState({ reworkObject: data });
                }
            }
        });
    }

    resetDetailsFields = () => {
        let object = this.state.reworkObject
        object.updateStatus = 0
        object.idRework = 0
        object.idReworkType = 1
        object.idJwOut = 0
        object.jwOutDate = ''
        object.avlStock = ''
        object.reworkQty = ''
        object.idProduct = 0
        object.productName = ''
        object.srNo = ''
        object.jwIn = ''
        object.jwInDate = ''
        object.idPlant = 0
        object.idProcess = 0
        object.isCompleteRework = false
        object.completeDate = ''
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            reworkObject: object
        });
    }

    addWoBomData = () => {
        this.resetItemObject()
        if (this.state.reworkObject.idProduct > 0) {
            this.getReworkBOMItems();
        } else {
            this.SwalServices.Alert('Please select product first')
        }
    }

    getReworkBOMItems = () => {
        let request = [this.state.reworkObject.idProduct, this.state.reworkObject.reworkQty, this.state.idCompany];
        this.transactionStockServices.getReworkBOMItems(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data && data.length > 0) {
                    const existingIds = new Set([
                        ...this.state.itemRowData.map((row) => row.idItem),
                        ...this.state.reworkRowData.map((row) => row.idItem),
                        ...this.state.bomRemovedRowData.map((row) => row.idItem),
                    ]);

                    const filteredData = data.filter((row) => !existingIds.has(row.idItem));

                    if (filteredData.length > 0) {
                        this.setState({ requiredQtyList: filteredData }, () => {
                            this.setState({ isQtyModelOpen: true });
                        });
                    } else {
                        this.SwalServices.Alert("All items are already added.");
                    }
                } else {
                    this.SwalServices.Alert(response.responseItem.responseContent)
                }
            }
        });
    }

    submit = () => {
        if (this.isSubmitting) { return; }
        let { reworkObject, itemRowData, bomRemovedRowData, idCompany, idUser, reworkRowData } = this.state;

        let stock = Number(reworkObject.avlStock) || 0;
        let reworkQty = Number(reworkObject.reworkQty) || 0;

        if (reworkQty > stock) {
            this.SwalServices.Alert('Rework Quantity cannot exceed Available Stock.');
            return;
        }

        if (reworkObject.idProduct === 0 || !reworkObject.reworkDate) {
            this.SwalServices.Alert('Please enter valid data. Product and Date are required.');
            return;
        }

        let request = {
            updateStatus: reworkObject.updateStatus || 0,
            idRework: reworkObject.idRework || 0,

            reworkNo: reworkObject.reworkNo || '',
            reworkDate: reworkObject.reworkDate || null,
            reWorkFrom: reworkObject.idReworkType === 1 ? 'FROM SALES RETURN' : 'FROM STOCK',
            idProduct: reworkObject.idProduct || 0,
            stockQuantity: stock,
            reworkQuantity: reworkQty,
            idPlant: reworkObject.idPlant || 0,
            remarks: reworkObject.remarks || '',
            isCompleteRework: reworkObject.isCompleteRework || false,
            completeDate: reworkObject.completeDate ? moment(reworkObject.completeDate).format('YYYY-MM-DD HH:mm:ss') : null,

            idCompany: idCompany,
            idUser: idUser,

            items: (itemRowData || []).map(item => ({
                itemType: item.itemType || '',
                idItem: item.idItem || 0,
                currentStock: Number(item.currentStock) || 0,
                requiredQuantity: Number(item.requiredQuantity || item.requiredQty) || 0,
                totalRequireQty: Number(item.totalRequireQty || item.totalRequiredQty) || 0,
                itemRate: Number(item.itemRate || item.itemRate) || 0,
                status: item.status ? 1 : 0
            })),

            removedItems: (bomRemovedRowData || []).map(item => ({
                idItem: item.idItem || 0,
                itemRate: Number(item.itemRate || item.itemRate) || 0,
                currentStock: Number(item.currentStock) || 0,
                quantity: Number(item.quantity) || 0
            })),

            semiFinishReworkItems: (reworkRowData || []).map(item => ({
                idItem: item.idItem || 0,
                idProcess: item.idProcess || 0,
                idEmployee: item.idEmployee || 0,
                processRates: Number(item.processRates || item.processRates) || 0,
                quantity: Number(item.quantity || item.quantity) || 0,
                isCompleteProcess: item.isCompleteProcess || 0,
                completeDate: moment(item.completeDate).isValid() ? moment(item.completeDate).format('YYYY-MM-DD HH:mm:ss') : null,
            })),
        };

        this.isSubmitting = true;
        this.setState({ isSaving: true });
        this.transactionStockServices.saveOrUpdateRework(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                this.SwalServices.Success("Rework Product saved successfully.");
                this.closePopup();
                this.procSelectAllRecordsSP();
                this.resetAllObject()
            } else {
                this.SwalServices.Error(response.responseItem?.responseContent || "Failed to save data.");
            }
        }).catch((error) => {
            this.SwalServices.Error("An error occurred while saving.");
            console.error(error);
        }).finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
    }

    insert = () => {
        let { itemObject, itemRowData, formStatus } = this.state;

        const stock = parseFloat(itemObject.stock) || 0;
        const qty = parseFloat(itemObject.quantity) || 0;
        const itemId = parseInt(itemObject.idItem) || 0;

        if (itemId > 0 && qty > 0 && qty <= stock) {

            const qty = Number(itemObject.quantity) || 0;
            if (formStatus === 0) {
                let newItem = {
                    itemDetails: itemObject.itemName,
                    idItem: itemId,
                    isItem: 1,
                    isGroup: 1,
                    idGroup: itemId,
                    totalRequireQty: qty,
                    requiredQuantity: Number(itemObject.requiredQuantity),
                    currentStock: stock,
                    itemRate: itemObject.itemRate,
                    drawingNo: itemObject.drawingNo,
                    itemType: itemObject.type,
                    status: 1,
                };

                this.setState({
                    itemRowData: [...itemRowData, newItem]
                });

            } else {
                // --- UPDATE MODE ---
                let updatedRows = itemRowData.map((row, index) => {
                    // Find the row by ID (corresponds to _iditem in C#)
                    if (index === this.state.itemObject.keyId) {
                        return {
                            ...row,
                            itemDetails: itemObject.itemName,
                            idItem: itemObject.idItem,
                            isItem: 1,
                            isGroup: 1,
                            idGroup: itemId,
                            totalRequireQty: qty,
                            currentStock: stock,
                            status: 1
                        };
                    }
                    return row;
                });

                this.setState({
                    itemRowData: updatedRows,
                    formStatus: 0
                });
            }

            this.setState({
                itemObject: {
                    ...itemObject,
                    idItem: 0,
                    stock: '',
                    quantity: '',
                    itemName: '',
                    remarks: '',
                    index: null
                }
            });

        } else {
            this.SwalServices.Error("Please Enter Valid Data. Ensure Quantity is not more than Available Stock.");
        }
    }

    clearItem = () => {
        let itemObject = this.state.itemObject
        this.setState({
            itemObject: {
                ...itemObject,
                idItem: 0,
                stock: '',
                quantity: '',
                itemName: '',
                remarks: '',
                type: '',
                keyId: null
            },
            formStatus: 0,
        });
    }

    deleteItem = () => {
        if (this.state.itemObject.idItem > 0 || this.state.itemObject.itemName) {
            this.setState({
                itemRowData: this.state.itemRowData.filter(row => row.idItem !== this.state.itemObject.idItem)
            }, () => {
                this.clearItem();
            });
        } else {
            this.SwalServices.Warning("Please select item to remove");
        }
    }

    getReworkById = (id) => {
        this.transactionStockServices.getReworkById(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem) {
                const data = response.responseItem.responseContent;
                const header = data.header;

                this.setState({
                    // 1. Map Header to reworkObject (Matches your TextInput/Dropdown values)
                    reworkObject: {
                        ...this.state.reworkObject,
                        reworkNo: header.reworkNo,
                        reworkDate: header.reworkDate ? moment(header.reworkDate).format('YYYY-MM-DD') : '',
                        reworkQty: header.reworkQuantity,
                        avlStock: header.stockQuantity,
                        remarks: header.remarks,
                        idProcess: header.idProcess,
                        idPlant: header.idPlant,
                        idProduct: header.idProduct,
                        productName: header.productName,
                        updateStatus: 1,
                        idRework: header.idRework,
                        isCompleteRework: header.isCompleteRework,
                        completeDate: header.completeDate ? moment(header.completeDate).format('YYYY-MM-DD') : '',
                        idReworkType: header.reWorkFrom ? this.state.reworkObject.reworkTypeList.find((x) => x.label === header.reWorkFrom).value : 1
                    },

                    // 2. Map Table 1 to Item Grid
                    itemRowData: data.items || [],

                    // 3. Map Table 2 to Removed Items Grid
                    bomRemovedRowData: data.removedItems || [],

                    // 4. Map Table 3 to Rework Items Grid
                    reworkRowData: data.reworkItems || [],

                    idRework: id
                }, () => {
                    this.setState({ isModalOpen: true });
                });
            } else {
                this.SwalServices.Error("Failed to load rework data.");
            }
        }).catch(error => {
            console.error("Error loading data:", error);
        });
    }

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.reworkObject;
        data.idProduct = event.data.idProduct;
        data.productName = event.data.productName;
        this.setState({ reworkObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems(event.data.idProduct);
        });
    };

    setOpenModel3 = () => {
        this.setState({ isQtyModelOpen: !this.state.isQtyModelOpen });
    };

    handleItemAdd = (data) => {
        if (data.currentStock >= data.totalRequireQty) {
            let itemObject = this.state.itemObject
            itemObject.drawingNo = data.drawingNo
            itemObject.itemName = data.itemDetails
            itemObject.idItem = data.idItem
            itemObject.stock = data.currentStock
            itemObject.quantity = data.totalRequireQty
            itemObject.totalRequireQty = data.totalRequireQty
            itemObject.requiredQuantity = data.requiredQuantity
            itemObject.itemRate = data.itemRate
            itemObject.type = data.itemType
            this.setState({ itemObject: itemObject, activeTab: 'items' }, () => {
                this.setOpenModel3()
            })
        } else {
            this.SwalServices.Alert('Quantity cannot exceed Available Stock.')
        }
        // const updatedData = { ...data, requiredQuantity: Number(data.requiredQuantity) };
        // this.setState((prevState) => ({
        //     itemRowData: [...prevState.itemRowData, updatedData],
        //     requiredQtyList: prevState.requiredQtyList.filter(
        //         (row) => row.idItem !== data.idItem
        //     ),
        // }));
    }

    handleItemRework = async (data) => {
        if (data.itemType === 'SEMI FINISHED') {
            // if (data.currentStock >= data.totalRequireQty) {
            const processItemSelectbyIDItem = (await this.transactionStockServices.usp_Master_ProcessItemSelectbyIDItem([data.idItem]))?.responseItem?.responseContent;
            if (processItemSelectbyIDItem.length > 0) {
                let reworkItemObject = this.state.reworkItemObject
                reworkItemObject.drawingNo = data.drawingNo
                reworkItemObject.itemName = data.itemDetails
                reworkItemObject.quantity = data.totalRequireQty
                reworkItemObject.processRates = data.itemRate
                reworkItemObject.idItem = data.idItem
                reworkItemObject.stock = data.currentStock
                reworkItemObject.type = data.itemType
                this.setState({ reworkItemObject: reworkItemObject, activeTab: 'rework' }, () => {
                    this.setOpenModel3()
                })
                // const updatedData = {
                //     ...data,
                //     quantity: data.totalRequireQty,
                //     idProcess: processItemSelectbyIDItem[0].idProcess,
                //     process: processItemSelectbyIDItem[0].process,
                //     processRates: processItemSelectbyIDItem[0].processRates,
                // };
                // this.setState((prevState) => ({
                //     reworkRowData: [...prevState.reworkRowData, updatedData],
                //     requiredQtyList: prevState.requiredQtyList.filter(
                //         (row) => row.idItem !== data.idItem
                //     ),
                // }));
            }
            // } else {
            //     this.SwalServices.Alert('Quantity cannot exceed Available Stock.')
            // }
        } else {
            this.SwalServices.Alert('Please select SEMI FINISHED item')
        }
    }

    handleItemRemove = (data) => {
        if (data.currentStock >= data.totalRequireQty) {
            let itemObject = this.state.itemObject
            itemObject.drawingNo = data.drawingNo
            itemObject.itemName = data.itemDetails
            itemObject.idItem = data.idItem
            itemObject.stock = data.currentStock
            itemObject.quantity = data.totalRequireQty
            itemObject.itemRate = data.itemRate
            itemObject.type = data.itemType
            this.setState({ itemObject: itemObject, activeTab: 'removed' }, () => {
                this.setOpenModel3()
            })
        } else {
            this.SwalServices.Alert('Quantity cannot exceed Available Stock.')
        }
        // const updatedData = { ...data, quantity: data.totalRequireQty };
        // this.setState((prevState) => ({
        //     bomRemovedRowData: [...prevState.bomRemovedRowData, updatedData],
        //     requiredQtyList: prevState.requiredQtyList.filter(
        //         (row) => row.idItem !== data.idItem
        //     ),
        // }));
    }

    onReworkDoubleClicked = (event) => {
        let reworkItemObject = this.state.reworkItemObject
        reworkItemObject.keyId = event.rowIndex
        reworkItemObject.itemName = event.data.itemDetails
        reworkItemObject.quantity = event.data.quantity
        reworkItemObject.process = event.data.process
        reworkItemObject.idProcess = event.data.idProcess
        reworkItemObject.processRates = event.data.processRates
        reworkItemObject.idEmployee = event.data.idEmployee
        reworkItemObject.employeeName = event.data.employeeName
        reworkItemObject.drawingNo = event.data.drawingNo
        reworkItemObject.isCompleteProcess = event.data.isCompleteProcess
        reworkItemObject.completeDate = moment(event.data.completeDate).format('YYYY-MM-DD')

        this.setState({ reworkItemObject: reworkItemObject }, () => {
            this.getEmployeeList()
        })
    }

    getEmployeeList = () => {
        if (this.state.reworkItemObject.idProcess > 0) {
            let request = [this.state.idCompany, this.state.reworkItemObject.idProcess];
            this.transactionStockServices.usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        dynamicData = dynamicData.map((x) => ({
                            value: x.idEmployee,
                            label: x.employeeName,
                        }));
                    }
                    let details = this.state.reworkItemObject;
                    details.employeeList = dynamicData
                    this.setState({ reworkItemObject: details })
                } else {
                    this.SwalServices.Error(response.message);
                }
            })
        }
    }

    updateReworkObject = () => {
        let { reworkItemObject, reworkRowData } = this.state;
        if (reworkItemObject.itemName === '' || reworkItemObject.idItem === '' || reworkItemObject.quantity === '') {
            this.SwalServices.Alert('Please enter valid data')
        } else {
            if (reworkItemObject.keyId !== undefined && reworkItemObject.keyId !== null) {
                const updatedReworkRowData = reworkRowData.map((item, index) => {
                    if (index === reworkItemObject.keyId) {
                        return { ...item, ...reworkItemObject };
                    }
                    return item;
                });

                this.setState({ reworkRowData: updatedReworkRowData }, () => {
                    this.resetReworkItemObject();
                });
            } else {
                const newItem = {
                    ...reworkItemObject,
                    itemDetails: reworkItemObject.itemName,
                    itemType: reworkItemObject.type,
                };

                this.setState({ reworkRowData: [...reworkRowData, newItem] }, () => {
                    this.resetReworkItemObject();
                });
            }
        }
    };

    updateBOMRemovedObject = () => {
        let itemObject = this.state.itemObject
        let bomRemovedRowData = this.state.bomRemovedRowData
        if (itemObject.keyId !== undefined && itemObject.keyId !== null) {
            const updatedReworkRowData = bomRemovedRowData.map((item, index) => {
                const qty = Number(itemObject.quantity) || 0;
                if (index === itemObject.keyId) {
                    return {
                        ...item,
                        ...itemObject,
                        quantity: qty
                    };
                }
                return item;
            });
            this.setState({ bomRemovedRowData: updatedReworkRowData }, () => {
                this.resetItemObject()
            });
        } else {
            const qty = Number(itemObject.quantity) || 0;
            const newItem = {
                ...itemObject,
                itemDetails: itemObject.itemName,
                currentStock: itemObject.stock,
                quantity: qty,
                keyId: bomRemovedRowData.length
            };

            this.setState({
                bomRemovedRowData: [...bomRemovedRowData, newItem]
            }, () => {
                this.resetItemObject();
            });
        }

    }

    resetReworkItemObject = () => {
        let reworkItemObject = this.state.reworkItemObject
        reworkItemObject.itemName = ''
        reworkItemObject.quantity = ''
        reworkItemObject.process = ''
        reworkItemObject.idProcess = ''
        reworkItemObject.employeeName = ''
        reworkItemObject.idEmployee = ''
        reworkItemObject.processRates = ''
        reworkItemObject.keyId = null
        reworkItemObject.isCompleteProcess = false
        reworkItemObject.completeDate = ''
        reworkItemObject.drawingNo = ''
        reworkItemObject.type = ''
        this.setState({ reworkItemObject: reworkItemObject })
    }

    handleChangeForReworkItem = (event, name) => {
        let value = event.target.value
        let details = this.state.reworkItemObject;
        if (name === "isCompleteProcess") {
            details.isCompleteProcess = !details.isCompleteProcess;
            details.completeDate = details.isCompleteProcess ? moment(new Date().toISOString()).format('YYYY-MM-DD') : '';
        } else if (name === "quantity") {
            details[name] = Number(value);
        } else {
            details[name] = value;
        }
        this.setState({ reworkItemObject: details });
    }

    resetItemObject = () => {
        let object = this.state.itemObject
        object.idItem = 0
        object.stock = ''
        object.quantity = ''
        object.remarks = ''
        object.itemName = ''
        object.type = ''
        object.totalRequireQty = ''
        object.keyId = null
        this.setState({ itemObject: object, formStatus: 0 })
    }

    resetAllObject = () => {
        this.resetDetailsFields()
        this.resetReworkItemObject()
        this.resetItemObject()
        this.setState({ itemRowData: [], reworkRowData: [], bomRemovedRowData: [] })
    }

    removeItemFromTables = (event, table) => {
        if (table === 'bomItems') {
            const updatedData = this.state.itemRowData.filter(row => row.idItem !== event.idItem);
            this.setState({ itemRowData: updatedData });
        } else if (table === 'bomRemove') {
            const updatedData = this.state.bomRemovedRowData.filter(row => row.idItem !== event.idItem);
            this.setState({ bomRemovedRowData: updatedData });
        } else if (table === 'bomRework') {
            const updatedData = this.state.reworkRowData.filter(row => row.idItem !== event.idItem);
            this.setState({ reworkRowData: updatedData });
        }
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idRework, "ReWork Product");
    };

    generateReportForReworkProduct = () => {
        if (this.state.reworkObject.idRework > 0) {
            let request = [this.state.reworkObject.idRework];
            this.transactionStockServices.generateReportForReworkProduct(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    setActiveTab = (activeTab) => {
        this.setState({ activeTab: activeTab })
    }

    render() {
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <ReworkProductTable
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            reworkObject={this.state.reworkObject}
                            itemObject={this.state.itemObject}
                            handleChangeForRework={this.handleChangeForRework.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForReworkItem={this.handleChangeForReworkItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            insert={this.insert.bind(this)}
                            clearItem={this.clearItem.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            bomRemovedRowData={this.state.bomRemovedRowData}
                            reworkRowData={this.state.reworkRowData}
                            itemColDefs={this.state.itemColDefs}
                            addWoBomData={this.addWoBomData.bind(this)}
                            onBomRowDoubleClicked={this.onBomRowDoubleClicked.bind(this)}
                            onItemRowDoubleClicked={this.onItemRowDoubleClicked.bind(this)}
                            handleOnClick={this.handleOnClick.bind(this)}
                            reworkItemObject={this.state.reworkItemObject}
                            onReworkDoubleClicked={this.onReworkDoubleClicked.bind(this)}
                            updateReworkObject={this.updateReworkObject.bind(this)}
                            updateBOMRemovedObject={this.updateBOMRemovedObject.bind(this)}
                            removeItemFromTables={this.removeItemFromTables.bind(this)}
                            generateReportForReworkProduct={this.generateReportForReworkProduct.bind(this)}
                            setActiveTab={this.setActiveTab.bind(this)}
                            activeTab={this.state.activeTab}
                            formStatus={this.state.formStatus}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Rework Product</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                // onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.reworkObject.productList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
                <QtyModel
                    isModalOpen={this.state.isQtyModelOpen}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    requiredQtyList={this.state.requiredQtyList}
                    colDefs={this.state.selectQtyColDefs}
                />
            </div>
        )
    }
}
